export default {
  enums: [
    { id: 'ELECTRONIC_DEVICE' },
    { id: 'PHYSICAL_DEVICE' },
  ]
};